import React, { useState, useCallback, useContext } from "react";

//Style
import { makeStyles } from "@material-ui/core/styles";

//Component
//--> Drawer
import SideDrawer from "../../components/Drawer/SideDrawer";
//--> Cover Image
import Cover from "../../components/Cover/Cover";
//--> Alert
import { Error, Success, Info } from "../../components/Alert/Alert";
//--> Forms
import Forms from "../../components/Forms/Forms";
//--> Drag and Drop
import DragNDrop from "../../components/DND/DragNDrop";
//--> Input
import SelectInput from "../../components/Input/SelectInput";
//--> Title
import Title from "../../components/Title";
//--> Tables
import Tables from "../../components/Table/Tables";

//Context
import { AgentContext } from "../../context/AgentContext";
import {
  ClientContext,
  ClientActionContext,
} from "../../context/ClientContext";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
}));

export default function Tasklist() {
  const classes = useStyles();

  //Context
  const { team } = useContext(AgentContext);
  const { clients, regClients } = useContext(ClientContext);
  const {
    registerClient,
    reassignClient,
    updateClient,
    readFile,
    demoClientFile,
    removeClient,
  } = useContext(ClientActionContext);

  //States
  //--> Forms
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [agentID, setAgentID] = useState("");
  const [agentID_G, setAgentID_G] = useState("");
  const [agentID_U, setAgentID_U] = useState("");
  //--> Alert
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  //--> Excel File
  const [file, setFile] = useState("");

  const handleAgentID = (e) => {
    setAgentID(e.target.value);
  };

  const handleAgentID_G = (e) => {
    setAgentID_G(e.target.value);
  };

  const handleAgentID_U = (e) => {
    setAgentID_U(e.target.value);
  };

  const TextBoxes = [
    {
      label: "Full Name",
      onChange: setFullName,
      value: fullName,
    },
    {
      label: "Phone Number",
      onChange: setPhoneNumber,
      value: phoneNumber,
      type: "phone",
    },
    {
      label: "Agent ID",
      onChange: handleAgentID,
      value: agentID,
      type: "select",
      menu: team,
    },
  ];

  const Excelheader = [
    "Avatar",
    "Name",
    "Phone Number",
    "Assign Agent",
    "Dismiss",
  ];

  const Clientsheader = [
    "Avatar",
    "Name",
    "Phone Number",
    "Last Assigned Agent",
    "Reassign Client",
    "Update Agent",
  ];

  //--> Excel Work Start
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
    // Do something with the files
  }, []);

  const handleExcel = () => {
    readFile(file, setErr);
    setTimeout(() => {
      setFile("");
    }, 3000);
  };
  //--> Excel Work End

  //--> Regester Agent Work Start
  const handleClientsubmit = () => {
    if (agentID && fullName && phoneNumber) {
      registerClient(
        fullName,
        phoneNumber,
        agentID,
        setAlertTitle,
        setErr,
        setSuccess,
      );
      setTimeout(() => {
        setFullName("");
        setPhoneNumber("");
        setAgentID("");
      }, 2000);
    } else {
      setErr("Please fill in all input box with required information!");
      setTimeout(() => {
        setErr("");
      }, 10000);
    }
  };

  const handleTableSubmit = (name, phoneNo) => {
    // console.log("--> Working --> ", name, phoneNo, agentID_G);
    if (agentID_G) {
      registerClient(
        name,
        phoneNo,
        agentID_G,
        setAlertTitle,
        setErr,
        setSuccess,
      );
      setTimeout(() => {
        removeClient(phoneNo);
      }, 2000);
    } else {
      setErr("Please select Agent before assigning!");
      setTimeout(() => {
        setErr("");
      }, 10000);
    }
  };

  const handleClientReassign = (name, phoneNo, clientID, agentID) => {
    reassignClient(
      name,
      phoneNo,
      clientID,
      agentID,
      setAlertTitle,
      setErr,
      setSuccess,
    );
  };

  const handleClientUpdate = (name, phoneNo, clientID) => {
    if (agentID_U) {
      updateClient(
        name,
        phoneNo,
        clientID,
        agentID_U,
        setAlertTitle,
        setErr,
        setSuccess,
      );
    } else {
      setErr("Please select Agent before updating!");
      setTimeout(() => {
        setErr("");
      }, 10000);
    }
  };
  //--> Regester Agent Work End

  //--> Handle Alert Start
  const Alert = err ? Error : success ? Success : null;
  const alert = err ? err : success ? success : null;
  //--> Handle Alert End

  return (
    <div style={{ display: "flex" }}>
      <SideDrawer />
      <div style={{ flex: 1 }}>
        <div className={classes.toolbar} />
        <Cover title="Clients Tasklist" />
        <div className={classes.content}>
          {alert !== null ? (
            <Alert
              title={alertTitle}
              msg={alert}
              style={{ margin: "0px 30px" }}
            />
          ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexFlow: "wrap-reverse",
              justifyContent: "center",
            }}
          >
            <DragNDrop
              onDrop={onDrop}
              file={file}
              handleSubmit={handleExcel}
              downloadFile={demoClientFile}
            />
            <Forms
              label="Clients Entry Form:"
              TextBoxes={TextBoxes}
              onSubmit={handleClientsubmit}
            />
          </div>
          <div style={{ margin: "50px 30px" }}>
            <TaskAssignSelect
              label="Agents List"
              value={agentID_G}
              handleChange={handleAgentID_G}
              menu={team}
              title="Assign Task to Agent"
              msg="Before assigning any client to agent make sure you have selected agent in selection. Thanks!"
            />
            {alert !== null ? <Alert title={alertTitle} msg={alert} /> : null}
            <Tables
              rows={clients}
              headers={Excelheader}
              submitLabel="Add Client"
              handleSubmit={handleTableSubmit}
              handleDelete={removeClient}
            />
          </div>

          <div style={{ margin: "0px 30px" }}>
            <Title title="Our Clients" overlay="Clients" />
            <TaskAssignSelect
              label="Agents List"
              value={agentID_U}
              handleChange={handleAgentID_U}
              menu={team}
              title="Reassign or Update Agent to Client"
              msg="Before updating or reassigning any client to agent make sure you have selected agent in selection. Thanks!"
            />
            {alert !== null ? <Alert title={alertTitle} msg={alert} /> : null}
            <Tables
              rows={regClients}
              headers={Clientsheader}
              handleReassign={handleClientReassign}
              submitLabel="Update"
              handleSubmit={handleClientUpdate}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const TaskAssignSelect = (props) => {
  const { label, value, handleChange, menu, title, msg } = props;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexFlow: "wrap",
        background: "#E8F4FD",
        padding: "10px",
      }}
    >
      <Info title={title} msg={msg} style={{ flex: 1 }} />
      <SelectInput
        label={label}
        value={value}
        onChangeEvent={handleChange}
        menuItems={menu}
        variant="filled"
        style={{ flex: 1 }}
      />
    </div>
  );
};
